'use strict'

module.exports = blockquote

var wrap = require('../wrap')
var all = require('../all')

/* Transform a block quote. */
function blockquote(h, node) {
  return h(node, 'blockquote', wrap(all(h, node), true))
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-html/~/mdast-util-to-hast/lib/handlers/blockquote.js
// module id = 209
// module chunks = 94053359063892 107818501498521